import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5172/api";

// ||"https://zynvert-847178596674.europe-west1.run.app/api";

/**
 * Product Service
 * ----------------
 * This file ONLY talks to backend product APIs.
 * It does NOT transform data.
 * Whatever backend sends → frontend receives.
 */
export const productService = {
  /**
   * Fetch products by display flag
   * Example flags:
   *  - "popular"
   *  - "featured"
   *  - "home"
   *  - "popular,home"
   */
  getByDisplayFlag: async (flag) => {
    const response = await axios.get(`${API_URL}/products/display/${flag}`);
    return response.data;
  },

  /**
   * Fetch all products
   * Used for Shop page / Admin listing
   */
  getAllProducts: async () => {
    const response = await axios.get(`${API_URL}/products`);
    return response.data;
  },

  /**
   * Fetch single product by Mongo _id
   * Used for Product Detail page
   */
  getProductById: async (mongoId) => {
    if (!mongoId) {
      throw new Error("Product ID is required");
    }

    const response = await axios.get(`${API_URL}/products/${mongoId}`);
    return response.data;
  },

  /**
   * Fetch products by category
   * Example:
   *  smart-li-ion-batteries
   */
  getByCategory: async (categoryId) => {
    if (!categoryId) {
      throw new Error("Category ID is required");
    }

    const response = await axios.get(
      `${API_URL}/products/category/${categoryId}`,
    );
    return response.data;
  },

  /**
   * Search products
   * Example query:
   *  battery
   */
  searchProducts: async (query) => {
    if (!query) return [];

    const response = await axios.get(`${API_URL}/products/search`, {
      params: { q: query },
    });

    return response.data;
  },
  // ─────────────────────────────────────────────────────────────
  // NEW: Notify Me Service
  // ─────────────────────────────────────────────────────────────
  requestRestockNotification: async (data) => {
    try {    
      const response = await axios.post(`${API_URL}/notifications/notify-me`, data);
      return response.data;
    } catch (error) {
      console.error("Failed to subscribe to restock notifications:", error);
      throw error;
    }
  },
};

export default productService;
